import { pilot } from '~/services/serviceInstances';

export const createAlert = async (data: any) => {
  return await pilot.post('alert/', data);
};
